import { FormControl, InputLabel, MenuItem, FormHelperText, Select } from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const MuiValidSelect = ({
  field,
  form: { touched, errors },
  variant,
  label,
  itemValues,
  itemLabels,
  sx,
  native = false,
  ...props
}) => {
  const keys = field.name.split('.');
  const error = keys.reduce((obj, key) => obj?.[key], touched);
  const errorMessage = keys.reduce((obj, key) => obj?.[key], errors);

  return (
    <FormControl sx={{ width: '100%', ...sx }}>
      <InputLabel error={error && !!errorMessage} id="select-label" variant={variant} shrink>
        {label}
      </InputLabel>
      <Select
        error={error && !!errorMessage}
        label={label}
        labelId="select-label"
        MenuProps={MenuProps}
        variant={variant}
        {...field}
        {...props}
        native={native}
        notched
      >
        {native
          ? [
              <option key="Default" value="" />,
              itemValues.map((val, index) => (
                <option key={val + index} value={val}>
                  {itemLabels[index]}
                </option>
              )),
            ]
          : [
              itemValues.map((val, index) => (
                <MenuItem key={val} value={val}>
                  {itemLabels[index]}
                </MenuItem>
              )),
            ]}
      </Select>
      <FormHelperText sx={{ ml: 0 }} error={error && !!errorMessage}>
        {error && errorMessage}
      </FormHelperText>
    </FormControl>
  );
};

export default MuiValidSelect;
